import styled from 'styled-components';

const FovTypography = styled('div')`
  font-size: ${props => props.fontSize / 16 || 1}rem;
  font-family: ${props => props.theme.typography.primary.regular};
`;

export { FovTypography };